import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSparkles } from '@fortawesome/pro-light-svg-icons/faSparkles';
import { TypedMemo } from '../../../common/types';
import { Panel } from '../../../music24/components/primitives/Panel';
import { useSMLRouter } from '../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../routing/sml/SMLRoutes';
import { SMLSettingsTabId } from '../types';
import { aiAssistantsMessages as messages } from './aiAssistantsMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the AI assistants tab; each part uses its own slice of it */
import styles from './aiAssistants.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * The line on Settings → API that points to Settings → AI assistants (design: ai-assistants e1).
 * It stands where the Connected apps list was.
 */
const AiAssistantsApiLinkComponent: React.FC = () => {
  const intl = useIntl();
  const router = useSMLRouter();
  const open = useCallback(() => router.push(SMLRoutes.settings, { tab: SMLSettingsTabId.aiAssistants }), [router]);
  const link = useCallback(
    (chunks: React.ReactNode) => (
      <button type="button" className={styles.apiLineLink} onClick={open}>
        {chunks}
      </button>
    ),
    [open]
  );
  return (
    <Panel nested pad className={styles.apiLine}>
      <FontAwesomeIcon icon={faSparkles} className={styles.apiLineIcon} />
      <span>{intl.formatMessage(messages.apiTabLink, { link })}</span>
    </Panel>
  );
};

export const AiAssistantsApiLink = TypedMemo(AiAssistantsApiLinkComponent);
